export const rules = {
  required: (v) => !!v || "Required.",
  name: (v) => (v && v.length >= 2) || "Invalid name.",
  email: (v) => /.+@.+\..+/.test(v) || "Invalid e-mail.",
  password: {
    min: (v) => (v && v.length >= 8) || "Min 8 characters.",
  },
  image: (v) =>
    /[/.](gif|jpg|jpeg|tiff|png)$/i.test(v ? v.name : "invalid.tgif") ||
    "File must be an image",
  excel: (v) =>
    /\.(xls[mx]?|csv)$/.test(v ? v.name : "invalid.txt") ||
    "File must be .xlsx or .xls",
  file: (v) => (v && v.size > 0) || "File is required",
  phone: (v) =>
    (v && /\d{10}/.test(v) && v.length === 10) || "Invalid phone number.",
  multiple: (v) => v.length > 0 || "Required.",
  username: (v) =>
    (v && /^(?:\d{10}|.+@.+\..+)$/.test(v)) || "Invalid email or phone.", // matches email or phone number
};

export const labelProps = {
  // class: "grey--text",
  style: "color: #1B3665",
  class: "font-weight-bold",
};

export const labelProps2 = {
  ...labelProps,
  class: "font-weight-normal",
};

export const fieldProps = {
  outlined: true,
  required: true,
  color: "primary",
  "hide-details": true,
  "single-line": true,
  class: "mt-1",
  dense: true,
  style: "background: rgba(0, 92, 255, 0.07);",
};

export const fieldProps2 = {
  ...fieldProps,
  dense: false,
  style: "background: rgba(0, 92, 255, 0.07);",
};

export const btnProps = {
  depressed: true,
};

export const btnProps2 = {
  ...btnProps,
  large: true,
  // class: "text-none",
};

export const toolbarProps = {
  dense: true,
  flat: true,
  color: "#f4f4f4",
  class: "rounded mb-4",
  style: "font-weight: bold; color: #1B3665;",
};

export const toSentenceCase = (param) => {
  const str = new String(param);
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
};

export const nFormatter = (num) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(1).replace(rx, "$1") + item.symbol
    : "0";
};

export const generateRandomColor = () => {
  return "#" + ((Math.random() * 0xffffff) << 0).toString(16);
};
